import { useSpring, animated, easings } from '@react-spring/web';
import { ReactNode } from 'react';

export function FadeIn({ children }: { children: ReactNode }) {
  const fadeIn = useSpring({
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
    config: { duration: 300, easing: easings.easeOutCirc },
  });
  return (
    <animated.div style={fadeIn} className="h-full w-full">
      {children}
    </animated.div>
  );
}
